import React, { useRef, useEffect } from 'react';
import Lottie from 'lottie-web';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
const HeaderComponentLeader = props => {
  const {
    teamworkTitle,
    teamworkDescription,
    teamworkButtonText,
    isLandingPage,
    landingImage,
    isLanding,
    isLead,
  } = props;
  const container = useRef(null);
  useEffect(() => {
    Lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../../animation/homepage.json'),
    });
  }, []);
  return (
    <div className="teamwork-section">
      <div className="full-container">
        <div className="team-section">
          <div className="row">
            <div
              className={`col-md-5 col-sm-12 order-md-1 order-2 ${
                isLanding ? 'landing-col' : ''
              }  ${isLead ? 'order-lg-1 ' : ''}`}
            >
              <div
                className={`teamwork-section_text leader-text-header ${
                  isLead ? 'teamwork-section_text-lead' : ''
                }`}
              >
                <h1
                  className={`teamwork-section_title leader-text-header-title leader-title ${
                    isLandingPage ? 'landing-title' : ''
                  }`}
                >
                  {teamworkTitle}
                </h1>
                <p
                  className={`teamwork-section_description ${
                    isLandingPage ? 'landing-description' : ''
                  } ${isLead ? 'teamwork-section_description-lead' : ''}`}
                >
                  {teamworkDescription}
                </p>
                <div className="teamwork-section_form-wrapper leader-section-button-header">
                  {!isLandingPage && (
                    <Link className="help-section-link" to="/contact">
                      {teamworkButtonText}
                    </Link>
                  )}
                </div>
              </div>
            </div>
            <div
              className={`col-md-7 col-sm-12 order-md-2 order-1 ${
                isLead ? 'order-lg-0 ' : ''
              }`}
            >
              {!isLandingPage && (
                <div className="lotti-container" ref={container}></div>
              )}
              {isLandingPage && (
                <GatsbyImage
                  image={landingImage}
                  style={{ width: '100%' }}
                  alt={''}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeaderComponentLeader;
